import { render, staticRenderFns } from "./EnergySimulation.vue?vue&type=template&id=48f8f74c"
import script from "./EnergySimulation.vue?vue&type=script&lang=js"
export * from "./EnergySimulation.vue?vue&type=script&lang=js"
import style0 from "./EnergySimulation.vue?vue&type=style&index=0&id=48f8f74c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports